import {
  GlobalQuestionLibraryCategoryModel,
  GlobalQuestionLibraryChangesPageModel,
  GlobalQuestionLibraryQuestionModel,
} from 'api/dto/GlobalQuestionLibrary.dto';
import { Resource } from 'model/Resource';
import { TakeLatestNew } from 'shared/utils/type';

export const STORE_NAME = 'globalQuestionLibrary';

export namespace GlobalQuestionLibraryState {
  export type Domain = {
    questions: Resource<GlobalQuestionLibraryQuestionModel[] | null>;
    categories: Resource<GlobalQuestionLibraryCategoryModel[] | null>;
    changes: TakeLatestNew<Resource<GlobalQuestionLibraryChangesPageModel | null>>;
  };

  export const INITIAL_DOMAIN: Domain = {
    questions: Resource.createPendingResource<GlobalQuestionLibraryQuestionModel[]>(),
    categories: Resource.createPendingResource<GlobalQuestionLibraryCategoryModel[]>(),
    changes: {
      data: Resource.createPendingResource<GlobalQuestionLibraryChangesPageModel>(),
      requestId: '',
    },
  };
}
